var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheeringMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arcticons:emoji-cheering-megaphone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.59527 5.57873C4.59527 5.57873 9.7536 5.84707 12.9183 3.67773M4.59527 9.5094C4.59527 9.5094 9.7536 9.24107 12.9183 11.4104M4.5946 9.51773L4.77694 10.4844H4.46494L4.79027 12.2101H4.89427L4.97327 12.6291L3.83427 12.6451L3.24427 9.5174M3.1826 5.57873H4.59493V9.45307H3.1826C2.9526 9.45307 2.7666 9.26673 2.7666 9.03707V5.99473C2.7666 5.76507 2.95293 5.57873 3.1826 5.57873Z",
    stroke: "#213332",
    strokeOpacity: 0.6,
    strokeWidth: 0.333333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.59501 5.57847C4.59501 5.57847 9.75334 5.8468 12.918 3.67747M4.59501 9.50914C4.59501 9.50914 9.75334 9.2408 12.918 11.4101M2.76634 6.16314H2.24901C2.01901 6.16314 1.83301 6.34914 1.83301 6.5788V8.43414C1.83301 8.66414 2.01934 8.85014 2.24901 8.85014H2.76634M3.34667 8.70214H3.97101M13.334 3.35547H13.7503C13.9803 3.35547 14.1663 3.5418 14.1663 3.77147V11.2598C14.1663 11.4898 13.98 11.6758 13.7503 11.6758H13.334C13.104 11.6758 12.918 11.4895 12.918 11.2598V3.77147C12.918 3.54147 13.1043 3.35547 13.334 3.35547Z",
    stroke: "#213332",
    strokeOpacity: 0.6,
    strokeWidth: 0.333333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheeringMegaphone);
export default __webpack_public_path__ + "static/media/cheering_megaphone.495d6eb12af4f2927367190730fa4429.svg";
export { ForwardRef as ReactComponent };